/**
 * Custom hook to get the label for a contact role
 * @param {Function} getMiddleText - Function to retrieve text from cms
 * @returns {Function} A function that takes a role and returns its label
 */
export const useContactRoleLabel = (getMiddleText) => {
  const getRoleLabel = (role) => {
    if (role === 'LEGAL_REPRESENTATIVE') {
      return getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_TITLE');
    }
    if (role === 'HR_MANAGER') {
      return getMiddleText('ENTREPRISE_CONTACT_RH_TITLE');
    }
    return '';
  };

  return getRoleLabel;
};
